import constants from '../../constants/constants'

export default {
    styleCanBeApplied: true,
    resizableSides: [constants.RESIZE_SIDES.LEFT, constants.RESIZE_SIDES.RIGHT],
    layoutLimits: {
        minWidth: 250
    }
}
